import { styled, Typography, TypographyProps } from '@mui/material';

export const PageTitle = styled(
  (props: TypographyProps & { isHighlighted?: boolean }) => (
    <Typography variant="headlineH3" {...props} />
  ),
)(({ theme, isHighlighted }) => ({
  color: isHighlighted
    ? theme.palette.primaries[500]
    : theme.palette.neutral[1000],
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.headlineH2,
  },
}));
